module.exports = __webpack_public_path__ + "67aac7ef6328ef41b314bcd048193aaf.svg";